// Íconos SVG en línea (sin pedidos extra; `currentColor` toma el color del botón).

const svg = (body: string, size = 20) =>
  `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`;

/** El destello de Laura (relleno). */
export const sparkle = (size = 24) =>
  `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.2 6.3 6.3 2.2-6.3 2.2L12 19.5l-2.2-6.3L3.5 11l6.3-2.2z"/><path d="M19 15.5l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z" opacity=".7"/></svg>`;

export const close = (size = 20) => svg('<path d="M18 6 6 18M6 6l12 12"/>', size);
export const send = () => svg('<path d="M12 19V5M5 12l7-7 7 7"/>');
export const newChat = () =>
  svg('<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>', 18);
export const copy = () =>
  svg(
    '<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
    15,
  );
export const check = () => svg('<path d="M20 6 9 17l-5-5"/>', 15);
export const arrowDown = () => svg('<path d="M12 5v14M19 12l-7 7-7-7"/>', 18);
export const alert = () => svg('<circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>', 18);
